// Server returns a generic 'default_heart_bkg.png' placeholder when a fund has no
// custom image. It is a near-black portrait graphic, so any landscape slot that
// renders it reads as a black box. Treat it as "no image" and fall through instead.
const PLACEHOLDER_IMAGE_TOKEN = 'default_heart_bkg';

export function isPlaceholderImage(url?: string | null): boolean {
  return !!url && url.includes(PLACEHOLDER_IMAGE_TOKEN);
}

export default isPlaceholderImage;
